module.exports = __webpack_public_path__ + "static/media/success.353eeb89.svg";